import React, {Component} from 'react';
import Actionbar from "../Common/Actionbar";
import Toast from '../Common/Toast';
import API from '../../services/API';
import {toast} from "react-toastify";
import EmptyPic from "../../assets/images/emptypic.png";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faCheck
} from '@fortawesome/free-solid-svg-icons'

class EditProfile extends Component {
    state={
        content : '',
        avatar: null,
        last_name: '',
        first_name: '',
        mobile: '',
        national_id: '',
        province: '',
        tel: '',
        description: '',
        city: '',
        email: '',
        file: null,
        pic: EmptyPic,
        provinces: [],
        cities: [],
        province_id: 0,
        city_id: 0,
        buttonStatus: "",
        buttonText : "ثبت تغییرات",
        loading: "d-none",
    }
    onFileChange = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            this.setState({
                pic: reader.result,
                file: event.target.files[0]
            })
        };

    }
    onInputChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;
        this.setState({[inputName]: inputValue});

    }
    onProvinceChange = (event) => {
        const province_id = event.target.value;
        this.setState({province_id});
        API.cities(province_id)
            .then((response) => {
                this.setState({cities: response.results.cities})
            })
    }
    onButtonClick = () => {
 /*       if(this.state.last_name.length < 3) {
            toast.error('لطفا نام خانوادگی را درست وارد کنید');
            return false
        }*/
        const buttonText  = "";
        const  loading = "d-inline-block";
        const buttonStatus = "disabled";
        this.setState({buttonText,loading,buttonStatus });
        const formData = new FormData();
        const file = this.state.file;
        if (file)
            formData.append('avatar', file);
        formData.append('last_name', this.state.last_name);
        formData.append('first_name', this.state.first_name);
        formData.append('national_id', this.state.national_id);
        formData.append('tel', this.state.tel);
        if(this.state.email)
            formData.append('email', this.state.email);
        formData.append('province_id', this.state.province_id);
        formData.append('city_id', this.state.city_id);
        formData.append('phone_specification', navigator.userAgent);

        API.updateProfile(formData)
            .then((response) => {
                toast.success(response.user_message);
                const buttonText  = "ثبت تغییرات";
                const  loading = "d-none";
                const buttonStatus = "";
                this.setState({buttonText,loading,buttonStatus });
            })
            .catch((error) => {

                toast.error(error.response.data.user_message);
                const buttonText  = "ثبت تغییرات";
                const  loading = "d-none";
                const buttonStatus = "";
                this.setState({buttonText,loading,buttonStatus });

            });
    }


    render() {
        return (
            <React.Fragment>
                <Toast/>
                <Actionbar noBack={0} title='ویرایش پروفایل'  />
                <section className="container rtl  p-3 usual-content mt-4 pt-5 ">
                    <div className="row">
                        <div className="col-12 text-center">
 {/*   <span onClick={this.onExitClick} className='p-2 badge badge-info badge-pill bg-danger'>
        خروج از اپلیکیشن
    </span>*/}
                        </div>
                        <div className="col-12 ">

                            <img alt="Avatar"
                                 src={(this.state.avatar && !this.state.file) ? this.state.avatar : this.state.pic }
                                 width={64} className='rounded-circle'/>
                            <span className="px-5">
                                                <label className="custom-file-upload float-left mt-3">
                                                    انتخاب تصویر پروفایل جدید
                                                 <input type="file" onChange={this.onFileChange}/>
                                                </label>
                                            </span>
                        </div>

                        <div className="form-floating col-md-6 mt-4">
                            <input type="text"
                                   className="form-control px-5"
                                   id="first_name" name="first_name"
                                   placeholder="نام"
                                   value={this.state.first_name}
                                   onChange={this.onInputChange}/>
                            <label htmlFor="first_name" className="right-0">نام</label>
                        </div>
                        <div className="form-floating col-md-6 mt-4">
                            <input type="text"
                                   className="form-control px-5"
                                   id="last_name" name="last_name"
                                   placeholder="نام خانوادگی"
                                   value={this.state.last_name}
                                   onChange={this.onInputChange}/>
                            <label htmlFor="last_name" className="right-0">نام خانوادگی</label>
                        </div>
                        <div className="form-floating col-md-6 mt-4">
                            <input type="text"
                                   className="form-control px-5 text-left"
                                   id="mobile" name="mobile"
                                   placeholder="شماره موبایل"
                                   value={this.state.mobile.replace('+98','0')}
                                   disabled
                            />
                            <label htmlFor="mobile" className="right-0">شماره موبایل</label>
                        </div>
                        <div className="form-floating col-md-6 mt-4">
                            <input type="text"
                                   className="form-control px-5"
                                   id="national_id" name="national_id"
                                   placeholder="کد ملی"
                                   value={this.state.national_id ? this.state.national_id : ''}
                                   onChange={this.onInputChange}
                            />
                            <label htmlFor="national_id" className="right-0">کد ملی</label>
                        </div>
                    </div>
                </section>
                <section className="container rtl my-5 p-3 usual-content pb-5 ">
                    <div className="row">
                        <div className="form-floating col-md-6 mt-4">
                            <input type="email"
                                   className="form-control px-5"
                                   id="email" name="email"
                                   placeholder="آدرس ایمیل"
                                   value={this.state.email ? this.state.email : ''}
                                   onChange={this.onInputChange}
                            />
                            <label htmlFor="email" className="right-0">آدرس ایمیل</label>
                        </div>
                        <div className="form-floating col-md-6 mt-4">
                            <input type="tel"
                                   className="form-control px-5"
                                   id="tel" name="tel"
                                   placeholder="شماره تماس ثابت"
                                   value={this.state.tel ? this.state.tel : ''}
                                   onChange={this.onInputChange}
                            />
                            <label htmlFor="tel" className="right-0">شماره تماس ثابت</label>
                        </div>
                        <div className="form-floating col-md-6 mt-4">
                            <select className="form-select" id="province_id" name="province_id"
                                    aria-label="Floating label select example"
                                    value={this.state.province_id}
                                    onChange={this.onProvinceChange}>
                                {this.state.provinces.map(pr => {
                                    return (
                                        <option value={pr.id} key={pr.id}>
                                            {pr.title}
                                        </option>
                                    )
                                })}
                            </select>
                            <label htmlFor="province_id" className="right-0">استان</label>
                        </div>
                        <div className="form-floating col-md-6 mt-4">
                            <select className="form-select" id="city_id" name="city_id"
                                    aria-label="Floating label select example"
                                    value={this.state.city_id}
                                    onChange={this.onInputChange}
                            >

                                {this.state.cities.map(ct => {
                                    return (
                                        <option value={ct.id} key={ct.id}>
                                            {ct.title}
                                        </option>
                                    )
                                })}
                            </select>
                            <label htmlFor="city_id" className="right-0">شهر</label>
                        </div>

                        <div className="col-12 p-2 fixed-bottom max-w-lg">
                            <button
                                className="btn btn-primary text-center bg-secondary-color text-semi-big w-100 p-2 pr-4"
                                onClick={this.onButtonClick}
                                disabled={this.state.buttonStatus}
                            >
                                <FontAwesomeIcon icon={faCheck}/>

                                &nbsp;
                                {this.state.buttonText}
                                <span  className={"spinner-grow spinner-grow-sm " + this.state.loading} role="status"
                                       aria-hidden="true">

                                </span>

                            </button>
                        </div>



                    </div>
                </section>

            </React.Fragment>
        );
    }
    componentDidMount = () => {

        API.profile()
            .then((response) => {
                this.setState(response.results.user)
                if (response.results.user.province) {
                    this.setState({
                        province_id: response.results.user.province.id,
                        city_id: response.results.user.city.id
                    })
                }

            })
        API.provinces(83)
            .then((response) => {
                this.setState({provinces: response.results.provinces})
            })

        API.cities(this.state.province_id)
            .then((response) => {
                this.setState({cities: response.results.cities})
            })

    }
}

export default EditProfile;